import React, { useState, useCallback, useMemo, useEffect } from 'react';
import _ from 'lodash';
import moment from 'moment';
import Utils from 'Utils';
import { CREATE_DELIVERY } from './create-delivery.mutation';
import { DELIVERIES } from './deliveries.query';
import DeliveriesList from '../DeliveriesList/DeliveriesList';
import { useLazyQuery, useMutation } from '@apollo/client';
import style from './style.scss';

const DeliveriesPage = ({ app_data }) => {
  const [selectedDate, setSelectedDate] = useState(Utils.format_date(moment()));
  const [createDelivery] = useMutation(CREATE_DELIVERY);
  const [getDeliveries, { loading, data, refetch }] = useLazyQuery(DELIVERIES, {
    pollInterval: 40000,
    fetchPolicy: 'no-cache',
  });

  const dateMoment = useMemo(() => moment(selectedDate, Utils.DATE_FORMAT), [selectedDate]);
  const addDelivery = useCallback(() => {
    async function load() {
      await createDelivery({
        variables: {
          date: dateMoment,
        }
      });
      getDeliveries({
        variables: {
          date: dateMoment,
        },
      });
    }
    load();
  }, [dateMoment]);

  console.log(data);
  const deliveryAccess = app_data.user.access.delivery;

  useEffect(() => {
    getDeliveries({
      variables: {
        date: dateMoment,
      },
    });
  }, [selectedDate, dateMoment])

  return (
    <div className={`container`}>
      <div className="deliveries_top">
        <div>
          <h1>Доставки</h1>
        </div>
        <div className="date_shift">
          {/*DOWN DATE BTN*/}
          <div
            className="date_shift__down"
            onClick={() => {
              setSelectedDate(
                moment(selectedDate, Utils.DATE_FORMAT)
                .add(-1, 'day')
                .format(Utils.DATE_FORMAT)
              );
            }}
          >
            <img height="20" src="/assets/icons/back.svg" alt=""/>
          </div>

          <div className="date_shift__date">
            {selectedDate}
          </div>

          {/*UP DATE BTN*/}
          <div
            className="date_shift__up"
            onClick={() => {
              setSelectedDate(
                moment(selectedDate, Utils.DATE_FORMAT)
                .add(1, 'day')
                .format(Utils.DATE_FORMAT)
              );
            }}
          >
            <img height="20" src="/assets/icons/next.svg" alt=""/>
          </div>
        </div>

        {deliveryAccess.all && <div
          className="button button_green button_big deliveries_top__add_btn"
          onClick={addDelivery}
        >
          + Доставка
        </div>}
      </div>
      {loading || !data ? <div>Загрузка</div> : <div>
        <DeliveriesList
          deliveries={data.deliveries}
          app_data={app_data}
          refetch={refetch}
          date_moment={dateMoment}
        />
      </div>}
    </div>
  );
}

export default DeliveriesPage;
